import { call, put, takeLatest } from "redux-saga/effects";
import axiosInstance from "utils/axiosInstance";

// Redux States
import { 
  FETCH_USER_POINTS,
  FETCH_USER_POINTS_SUCCESS,
  FETCH_USER_POINTS_FAILURE,
  FETCH_MENU_IMAGES_SUCCESS,
} from "./actionTypes";

function* fetchUserPointsSaga() {
  try {
    const response = yield call(axiosInstance.get, '/knovia/myInfo/infoPoints');
    yield put({ type: FETCH_USER_POINTS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: FETCH_USER_POINTS_FAILURE, payload: error.message });
  }
}

function* pointsSaga() {
  yield takeLatest(FETCH_USER_POINTS, fetchUserPointsSaga);
}

export default pointsSaga;


